
var developer_mode = localStorage.getItem('active_console');

if(!developer_mode) {
    console.log = function(){};
    console.warn = function(){};
    console.error = function(){};
    window.console = console;
}


if(true) {
    console.warn = function(){};
    window.console = console;
}
